module.exports = __webpack_public_path__ + "img/loading.b4cfbbab.png";